export const AdminMenus = [
  { header: "General" },
  { icon: "home", text: "Home", to: "/dashboard" },
  { icon: "people", text: "User", to: "/users" },
  { icon: "account_balance", text: "Warehouse", to: "/warehouses" },
  { icon: "store", text: "Shop", to: "/shops" },
  { icon: "computer", text: "Counter", to: "/counters" },
  { icon: "shopping_basket", text: "Card", to: "/cards" },
  { icon: "format_list_numbered", text: "System Serialize", to: "/system-serializes" },
  { icon: "credit_card", text: "Credit Level", to: "/credit-levels" },
  { icon: "account_box", text: "Customer", to: "/customers" },
  { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
  { header: "Tax Management" },
  { icon: "receipt", text: "Tax", to: "/taxs" },
  { icon: "receipt", text: "Discount", to: "/discounts" },
  { header: "Currency Management" },
  { icon: "shop", text: "Currency List", to: "/currencies" },
  { icon: "shop", text: "Currency Exchange Rate", to: "/currency-exchange-rates" },
  { header: "Product Management" },
  { icon: "loyalty", text: "Brand", to: "/brands" },
  { icon: "widgets", text: "Category", to: "/categories" },
  { icon: "ac_unit", text: "Unit", to: "/units" },
  { icon: "group_work", text: "Product Group", to: "/product-groups" },
  { icon: "card_membership", text: "Product", to: "/products" },
  { header: "Purchasing" },
  { icon: "shopping_basket", text: "Purchase Order", to: "/purchase-order" },
  { header: "Warehouse Management" },
  { icon: "photo_library", text: "Stock In", to: "/stockins" },
  { icon: "local_shipping", text: "Stock Transfer", to: "/stock-transfers" },
  { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
  { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
  { header: "Counter Cash Management" },
  { icon: "credit_card", text: "Counter Cash", to: "/counter-cashs" },
  { icon: "note", text: "Cash Note", to: "/cash-notes" },
  { icon: "list", text: "Denomination", to: "/denominations" },
  { header: "Sale" },
  { icon: "assignment", text: "Whole Sale", to: "/whole-sales" },
  { icon: "assignment_return", text: "Sale Return", to: "/sale-return" },
  { header: "Reports" },
  { icon: "report", text: "Sale Report", to: "/sale-report" },
  { icon: "report", text: "Product Sale Report", to: "/menu-report" },
  { icon: "report", text: "Counter Cash Report", to: "/counter-cash-report" },
  { icon: "report", text: "Cash In Hand Report", to: "/cash-in-hand-report" },
  { icon: "report", text: "Credit Balance Report", to: "/customer-credit-balance" },
  { icon: "report", text: "Account Receivable Report", to: "/account-receivable-report" },
  { icon: "report", text: "Stock Return Report", to: "/stock-return-report" },
  { icon: "report", text: "Stock Valuation  Report", to: "/stock-valuation-report" },
  { icon: "report", text: "Stock Movement  Report", to: "/stock-movement-report" },
  { icon: "report", text: "Cash Report", to: "/cash-report" },
  { header: "Stock Management" },
  { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
  { header: "Credit Cash Flow" },
  { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },
];

export const WarehouseManagerMenus = [
  { header: "General" },
  { icon: "home", text: "Home", to: "/dashboard" },
  { header: "Warehouse Management" },
  { icon: "photo_library", text: "Stock In", to: "/stockins" },
  { icon: "local_shipping", text: "Stock Transfer", to: "/stock-transfers" },
  { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
  { header: "Product Management" },
  { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
  { header: "Purchasing" },
  { icon: "shopping_basket", text: "Purchase Order", to: "/purchase-order" },
  { header: "Stock Management" },
  { icon: "photo_library", text: "Stock Take", to: "/stock-takes" }
];

export const SaleManagerMenus = [
  { header: "General" },
  { icon: "home", text: "Home", to: "/dashboard" },
  { icon: "store", text: "Shop", to: "/shops" },
  { icon: "computer", text: "Counter", to: "/counters" },
  { header: "Product Management" },
  { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
  { header: "Price Model Management" },
  { icon: "attach_money", text: "Price Model", to: "/price-models" },
  { header: "User Management" },
  { icon: "assignment", text: "Shift Info Setup", to: "/shift-infos" },
  { icon: "assignment_ind", text: "Shift Assign", to: "/shift-assigns" },
  { header: "Counter Cash Management" },
  { icon: "credit_card", text: "Counter Cash", to: "/counter-cashs" },
  { icon: "note", text: "Cash Note", to: "/cash-notes" },
  { icon: "list", text: "Denomination", to: "/denominations" },
  { header: "Sale" },
  { icon: "assignment", text: "Whole Sale", to: "/whole-sales" },
  { icon: "assignment_return", text: "Sale Return", to: "/sale-return" },
  { header: "Reports" },
  { icon: "report", text: "Counter Cash Report", to: "/counter-cash-report" },
  { header: "Credit Cash Flow" },
  { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },

];

export const SaleMenus = [
  { header: "General" },
  { icon: "home", text: "Home", to: "/dashboard" },
  { icon: "local_grocery_store", text: "Sale", to: "/sales/new" },
  { icon: "local_grocery_store", text: "Saleperson Sales", to: "/saleperson-sales" }
];

export const SalePersonMenus = [
  { header: "General" },
  { icon: "home", text: "Home", to: "/dashboard" },
  { icon: "report", text: "Sale Report", to: "/saleperson-sale-report" },
]

export const BranchAdminMenus = [
  { header: "General" },
  { icon: "home", text: "Home", to: "/dashboard" },
  { icon: "people", text: "User", to: "/users" },
  { icon: "account_balance", text: "Warehouse", to: "/warehouses" },
  { icon: "store", text: "Shop", to: "/shops" },
  { icon: "computer", text: "Counter", to: "/counters" },
  { icon: "shopping_basket", text: "Card", to: "/cards" },
  { icon: "format_list_numbered", text: "System Serialize", to: "/system-serializes" },
  { icon: "credit_card", text: "Credit Level", to: "/credit-levels" },
  { icon: "account_box", text: "Customer", to: "/customers" },
  { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
  { header: "Tax Management" },
  { icon: "receipt", text: "Tax", to: "/taxs" },
  { icon: "receipt", text: "Discount", to: "/discounts" },
  { header: "Currency Management" },
  { icon: "shop", text: "Currency List", to: "/currencies" },
  { icon: "shop", text: "Currency Exchange Rate", to: "/currency-exchange-rates" },
  { header: "Purchasing" },
  { icon: "shopping_basket", text: "Purchase Order", to: "/purchase-order" },
  { header: "Warehouse Management" },
  { icon: "photo_library", text: "Stock In", to: "/stockins" },
  { icon: "local_shipping", text: "Stock Transfer", to: "/stock-transfers" },
  { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
  { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
  { header: "Counter Cash Management" },
  { icon: "credit_card", text: "Counter Cash", to: "/counter-cashs" },
  { icon: "note", text: "Cash Note", to: "/cash-notes" },
  { icon: "list", text: "Denomination", to: "/denominations" },
  { header: "Sale" },
  { icon: "assignment", text: "Whole Sale", to: "/whole-sales" },
  { icon: "assignment_return", text: "Sale Return", to: "/sale-return" },
  { header: "Reports" },
  { icon: "report", text: "Sale Report", to: "/sale-report" },
  { icon: "report", text: "Product Sale Report", to: "/menu-report" },
  { icon: "report", text: "Counter Cash Report", to: "/counter-cash-report" },
  { icon: "report", text: "Cash In Hand Report", to: "/cash-in-hand-report" },
  { icon: "report", text: "Credit Balance Report", to: "/customer-credit-balance" },
  { icon: "report", text: "Account Receivable Report", to: "/account-receivable-report" },
  { icon: "report", text: "Stock Return Report", to: "/stock-return-report" },
  { icon: "report", text: "Stock Valuation  Report", to: "/stock-valuation-report" },
  { icon: "report", text: "Stock Movement  Report", to: "/stock-movement-report" },
  { icon: "report", text: "Cash Report", to: "/cash-report" },
  { header: "Stock Management" },
  { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
  { header: "Credit Cash Flow" },
  { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },
];

